import { Organization, Tenant, TenantMembership, TenantMembershipRoleName } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Input, Table, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { ConfirmModal } from "../../modals/confirm-modal.modal";
import { membershipService, organizationService } from "../../services";
import { GrantOrgMembershipModal } from "../../modals/grant-org-membership.modal";

type OrganizationMembershipsTableProps = {
    memberships: TenantMembership[];
    organization?: Organization;
    tenant?: Tenant;
    onChange: () => void;
};

export const OrganizationMembershipsTable = ({
    memberships,
    organization,
    tenant,
}: OrganizationMembershipsTableProps) => {
    const [dooomedMembership, setDoomedMembership] = useState<TenantMembership>();
    const deleteControl = useDisclosure();
    const grantControl = useDisclosure();
    const [query, setQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const removeMembership = async () => {
        try {
            setIsLoading(true);
            if (dooomedMembership) {
                await membershipService.revokeMembership(dooomedMembership.id);
            }
        } finally {
            setIsLoading(false);
            setDoomedMembership(undefined);
            deleteControl.onClose();
        }
    };

    const handleRemoveButtonClick = (membership: TenantMembership) => {
        setDoomedMembership(membership);
        deleteControl.onOpen();
    };

    const search = () => {

    };

    const grantMembership = async (tenantId: string, organizationId: string, role: TenantMembershipRoleName) => {
        try {
            setIsLoading(true);
            await organizationService.updateOrganizationById(organizationId, {
                membership: {
                    add: { tenantId, role },
                },
            });
        } finally {
            grantControl.onClose();
            setIsLoading(false);
        }
    };

    return (
        <Box>
            <Flex>
                <form onSubmit={search}>
                    <Flex>
                        <Input onChange={(e) => setQuery(e.target.value)} value={query} placeholder="search..." type={'search'} />
                        <Button type="submit" onClick={search} ml={2} colorScheme="primary">Search</Button>
                    </Flex>
                </form>
                <Button ml={'auto'} colorScheme="teal" onClick={grantControl.onOpen}>Grant Membership</Button>
            </Flex>
            {memberships.length > 0 ? <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>Id</Th>
                        <Th>Tenant ID</Th>
                        <Th>Tenant Name</Th>
                        <Th>Roles</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {memberships.map((membership) => (
                        <Tr key={membership.id}>
                            <Td>{membership.id}</Td>
                            <Td>{membership.tenantId}</Td>
                            <Td>{membership.tenant?.name}</Td>
                            <Td>{membership.roles?.map((r) => r.name).join(', ')}</Td>
                            <Td>
                                <Button mr={2} size="sm" colorScheme="danger" onClick={() => handleRemoveButtonClick(membership)}>
                                    Revoke
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table> : <Box textAlign={'center'} mt={5}>
                No memberships found.
            </Box>}
            {dooomedMembership && <ConfirmModal
                isOpen={deleteControl.isOpen}
                message={`Are you sure you want to revoke this membership?`}
                onCancel={deleteControl.onClose}
                onClose={deleteControl.onClose}
                onConfirm={removeMembership}
            />}
            <GrantOrgMembershipModal
                isOpen={grantControl.isOpen}
                onClose={grantControl.onClose}
                onGrant={grantMembership}
                initialOrg={organization}
                initialTenant={tenant}
                isLoading={isLoading}
            />
        </Box>
    )
}